import { connect } from 'react-redux'
import {
  getOccupations,
  setFilterName,
  setFilterSortLiveData,
  setOccupationLiveDataSelected,
  setIsModalMergeOpen,
  setDataTypeActive,
} from 'reduxpath/ducks/Occupation/List'

import {
  setAddNewOccupation,
  setData,
  setOccupation,
} from 'reduxpath/ducks/Occupation/Add'

import {
  setSelectedData,
  updateOccupation,
} from 'reduxpath/ducks/Occupation/Edit'

import {
  setModalDelete,
  removeOccupation,
  setIdOccupationToDelete,
} from 'reduxpath/ducks/Occupation/Remove'

import Occupations from 'components/TopicsOccupation/LiveData'

const mapStateToProps = state => ({
  dataList: state.OccupationList.data,
  isAddNewData: state.OccupationAdd.isAddNewOccupation,
  dataInput: state.OccupationAdd.data.name,
  dataAdd: state.OccupationAdd.data,
  isEditActive: state.OccupationEdit.isEditActive,
  selectedData: state.OccupationEdit.selectedData,
  isModalDeleteOpen: state.OccupationRemove.isModalDeleteOpen,
  idDataToDelete: state.OccupationRemove.idOccupationToDelete,
  user: state.Auth.me.user,
  filterName: state.OccupationList.filterName,
  addButtonLabel: '+ Add new Occupations',
  liveDataFilter: state.OccupationList.liveDataFilter,
  dataLiveSelected: state.OccupationList.occupationLiveDataSelected,
  existingDataSelected: state.OccupationList.existingOccupationSelected,
  inputMergeName: state.OccupationList.inputMergeName,
  typeMerge: state.OccupationList.typeMerge,
})

const mapDispatchToProps = dispatch => ({
  handlePageChange(filterName, liveDataFilter) {
    return (key) => {
      const limit = 10
      const qs = {
        limit,
        skip: key.selected * limit,
      }
      if (liveDataFilter.sort) {
        qs.sort = `${liveDataFilter.active} ${liveDataFilter.sort}`
      }
      if (filterName) {
        qs.where = {
          name: {
            like: `%${filterName}%`,
          },
        }
      }
      dispatch(getOccupations(qs))
    }
  },

  setInputNewData(value) {
    return () => {
      const inputData = {
        data: {
          name: '',
          status: 2,
        },
      }
      dispatch(setData(inputData))
      dispatch(setAddNewOccupation(value))
    }
  },

  setInputdata(e) {
    const data = {
      name: e.target.value,
      status: 2,
    }
    dispatch(setData({ data }))
  },

  addNewData(dataAdd) {
    return () => {
      dispatch(setOccupation(dataAdd, () => {
        const qs = {
          sort: 'createdAt ASC',
          limit: 10,
          skip: 0,
        }

        const stateData = {
          data: {
            name: '',
          },
        }

        dispatch(getOccupations(qs))
        dispatch(setData(stateData))
        dispatch(setAddNewOccupation(false))
      }))
    }
  },

  setEditState(data) {
    return () => {
      const inputData = {
        id: data.id,
        name: data.name,
      }
      dispatch(setSelectedData(inputData))
    }
  },

  onChangeEditValue(data) {
    return (e) => {
      const inputData = {
        id: data.id,
        name: e.target.value,
      }
      dispatch(setSelectedData(inputData))
    }
  },

  updateData(data, id) {
    return () => {
      dispatch(updateOccupation(data, id, () => {
        const qs = {
          sort: 'createdAt ASC',
          limit: 10,
          skip: 0,
        }

        dispatch(getOccupations(qs))
        dispatch(setSelectedData({
          id: '',
          name: '',
        }))
      }))
    }
  },

  setModalDeleteOpen(data, idOccupation = '') {
    return () => {
      dispatch(setIdOccupationToDelete(idOccupation))
      dispatch(setModalDelete(data))
    }
  },

  deleteData(id) {
    return () => {
      dispatch(removeOccupation(id, () => {
        const qs = {
          sort: 'createdAt ASC',
          limit: 10,
          skip: 0,
        }

        dispatch(setModalDelete(false))
        dispatch(getOccupations(qs))
        dispatch(setIdOccupationToDelete(''))
      }))
    }
  },

  onSearchFilter(liveDataFilter) {
    return (e) => {
      const limit = 10
      const qs = {
        limit,
        skip: 0,
        where: {
          name: {
            like: `%${e.target.value}%`,
          },
        },
      }
      if (liveDataFilter.sort) {
        qs.sort = `${liveDataFilter.active} ${liveDataFilter.sort}`
      }
      dispatch(setFilterName(e.target.value))
      dispatch(getOccupations(qs))
    }
  },

  sortLiveData(filterName) {
    return data => () => {
      const qs = {
        skip: 0,
        where: {
          name: {
            like: `%${filterName}%`,
          },
        },
        sort: `${data.active} ${data.sort}`,
      }
      dispatch(getOccupations(qs))
      dispatch(setFilterSortLiveData(data))
    }
  },

  onClickCheckBox(currentData) {
    return selectedData => (e) => {
      const currentSelectedData = [...currentData]
      if (e.target.checked) {
        currentSelectedData.push(selectedData)
      } else {
        const dataIndex = currentSelectedData.findIndex(data => data.id === selectedData.id)
        currentSelectedData.splice(dataIndex, 1)
      }
      dispatch(setOccupationLiveDataSelected(currentSelectedData))
    }
  },

  clearSelection() {
    dispatch(setOccupationLiveDataSelected([]))
  },

  setIsModalMergeOpen(data) {
    return () => {
      dispatch(setDataTypeActive('liveData'))
      dispatch(setIsModalMergeOpen(data))
    }
  },
})

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  ...dispatchProps,
  addNewData: dispatchProps.addNewData(stateProps.dataAdd),
  onChangeEditValue: dispatchProps.onChangeEditValue(stateProps.selectedData),
  updateData: dispatchProps.updateData(stateProps.selectedData, stateProps.selectedData.id),
  deleteData: dispatchProps.deleteData(stateProps.idDataToDelete),
  handlePageChange: dispatchProps.handlePageChange(
    stateProps.filterName,
    stateProps.liveDataFilter,
  ),
  sortLiveData: dispatchProps.sortLiveData(stateProps.filterName),
  onSearchFilter: dispatchProps.onSearchFilter(stateProps.liveDataFilter),
  onClickCheckBox: dispatchProps.onClickCheckBox(stateProps.dataLiveSelected),
})

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Occupations)
